import {FETCH_COMPANY_REQUEST, FETCH_COMPANY_SUCCES, FETCH_COMPANY_ERROR} from '../constants/Company'
import { jsonGet, errorHandler } from '../utils/Request';

const loadCompany = id => (dispatch) => {
  const apiUrl = '/company/' + id;
  dispatch({
    type: FETCH_COMPANY_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_COMPANY_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_COMPANY_ERROR
      });
      errorHandler(e);
    });
};

export { loadCompany };



// WEBPACK FOOTER //
// ./src/actions/CompanyActions.js